module.exports = __webpack_public_path__ + "img/plug-ext.d08b8e69.png";